export default import.meta.ROLLDOWN_FILE_URL_XknXXTLexZfe83M8xxoHgg